import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Printer, Tags } from 'lucide-react';
import { Button } from '../components/ui/button';
import api from '../lib/api';
import { message, savePdf } from './PackToolShell';
import { LabelProfileSelect } from './LabelProfileSelect';

export const RelabelQueue = ({ canManage }) => {
  const [items, setItems] = useState(null);
  const [profile, setProfile] = useState('default');
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api.get('/opened-packs/relabel-queue').then(r => setItems(r.data.items)).catch(() => setItems([])), []);
  useEffect(() => { load(); }, [load]);
  const print = async () => {
    setBusy(true);
    try {
      const r = await api.get('/opened-packs/relabel-batch', { params: { profile_id: profile }, responseType: 'blob' });
      savePdf(r.data, 'relabel-batch.pdf');
      toast.success('Label batch downloaded — print it and work down the list');
      load();
    } catch (e) { toast.error(message(e)); } finally { setBusy(false); }
  };
  if (!items?.length) return null;
  return <section className="pack-empty" data-testid="relabel-queue">
    <h2 className="flex items-center gap-2"><Tags size={18} /> Packs needing a new label ({items.length})</h2>
    <p className="pack-note">These packs still carry an old long code. Print the whole batch at once, then stick each label on the pack listed below — the shelf is caught up in one pass.</p>
    {canManage && <div className="pack-relabel-print">
      <LabelProfileSelect value={profile} onChange={setProfile} />
      <Button size="sm" disabled={busy} onClick={print} data-testid="relabel-print-batch"><Printer size={16} /> Print all {items.length} labels</Button>
    </div>}
    <div className="pack-relabel-list">
      {items.map(row => <div key={row.pack_id} className="pack-empty-row" data-testid={`relabel-row-${row.pack_id}`}>
        <div><strong>{row.pack_id}</strong> · {row.name}
          <small className="block">Shelf {row.shelf || 'Unassigned'} · Batch {row.batch_number} · {row.remaining} left{row.old_pack_id ? ` · replaces ${row.old_pack_id}` : ''}</small>
        </div>
      </div>)}
    </div>
    {!canManage && <p className="pack-note">Ask a stock manager to print the new labels.</p>}
  </section>;
};
